<template>
  <div class="convo-container" :class='{mobile: liveCallMobile}'>

    <MsgBanner v-if="data.showBannerVar" v-bind:link="carwars ? 'https://www.carwars.com/home/resources/a/10DLC-affects-texting-your-customers.cfm' : 'https://www.callbox.com/resources/dental/a/10DLC-affects-texting-your-customers.cfm'">
      <i class="zmdi zmdi-alert-triangle" slot="icon"></i>
      <label class="coss" slot="message">
        New regulations require businesses to register their texting lines to ensure messages are successfully delivered.
        <br><span class='coss gray1'>Click here to learn more and provide us the information necessary to register.</span>
      </label>
    </MsgBanner>

    <div class="convo-box">
      <div class="headline">
        <div class='headline-top'>
          <div class="headline-user">
            <div class='user'>
              <div class='user-meta'>
                <div class='user-meta-top'>
                  <h2 class='user-name' v-if="currentThread.name && currentThread.name != 'Customer'">{{currentThread.name}}</h2>
                  <h2 class='user-name' v-else-if="noteData.displayCustomerName">{{noteData.displayCustomerName}}</h2>
                  <h2 class='user-name' v-else-if="currentThread.name">{{currentThread.name}}</h2>
                  <div class='userPhoneWrap'>
                    <label class='user-phone' v-if="currentThread.phone" @click='popup.blockPop = true'>{{formatNumber(currentThread.phone)}}</label>

                    <i class="zmdi zmdi-check-all" v-if="customerConsent && customerConsent.optedIn"/>
                    <i class="zmdi zmdi-block" v-if="customerConsent && customerConsent.optedOut"/>
                  </div>
                </div>

                <div class='user-location' v-if="account.refname && (account.refname != '') && callCenterAgents.length > 0">
                  <i class='zmdi zmdi-pin'></i>
                  <label class='sub'>{{account.refname}}</label>
                </div>
              </div>

              <i class='zmdi zmdi-chevron-down' v-if='liveCallMobile' @click='expandMobileTopDisplay()' :class='{flip: data.tempData.liveCallMobileExpanded}'></i>
            </div>

            <div v-if='currentThread.campaigns.length'  v-for="(campaign, index) in currentThread.campaigns">
              <div class="campaignRow">
                <div v-if="!liveCallMobile">
                  <i class='zmdi zmdi-chevron-down campaignToggle'  @click='toggleExpandCampaign(index)' :class='{flip: campaign.expanded}'></i>
                </div>
                <label class="sub">{{campaign.campaignName}}</label>
              </div>
              <div class="user-info" v-if="campaign.campaignName && campaign.campaignLabels && campaign.campaignLabels.length && !liveCallMobile && campaign.expanded">
                <div class="campaignInfoBar" v-for="(campaignLabel, index) in campaign.campaignLabels" :class="{left: index % 2 == 0}">
                    <label class="small">{{campaignLabel.label}}</label>
                    <div>{{campaignLabel.data || 'N/A' }}</div>
                </div>
              </div>
            </div>

            <div class='user-info' v-if='(noteData.hasInfo || noteData.hasDSInfo || noteData.hasVinInfo) && ((liveCallMobile && data.tempData.liveCallMobileExpanded) || !liveCallMobile)'>
              <!-- Service Advisor -->
              <conversationIconKey class='info' :hasIcon="true" v-if="noteData.displayServicePerson">
                <i class='zmdi zmdi-assignment-account' slot="icon"></i>
                <label class='sub' slot="keyLabel">
                  Service Advisor: {{ noteData.displayServicePerson }}
                </label>
              </conversationIconKey>

              <!-- Service Appointment -->
              <conversationIconKey class='info' :hasIcon="true" :class="{red: noteData.displayCalendarServiceRed }" v-if="noteData.displayCalendarService">
                <i class='zmdi zmdi-calendar-alt' slot="icon"></i>
                <label class="sub" slot="keyLabel">
                  {{ noteData.displayCalendarService }}
                </label>
              </conversationIconKey>

              <!-- Repair Order -->
              <conversationIconKey class="info" :hasIcon="true" v-if="noteData.displayWrench">
                <i class="zmdi zmdi-wrench" slot="icon"></i>
                <label class='sub' slot="keyLabel">
                  RO Status: {{ noteData.displayWrench }}
                </label>
              </conversationIconKey>

              <!-- Sales person -->
              <conversationIconKey class="info" :hasIcon="true" v-if="noteData.displaySalesPerson">
                <i class='zmdi zmdi-assignment-account' slot="icon"></i>
                <label class='sub' slot="keyLabel">
                  Salesperson: {{ noteData.displaySalesPerson }}
                </label>
              </conversationIconKey>

              <!--- Active lead --->
              <conversationIconKey class="info" :hasIcon="true" :class="{red: noteData.displayCar1Red }" v-if="noteData.displayCar1">
                <i class='zmdi zmdi-car' slot="icon"></i>
                <label class='sub' slot="keyLabel">
                  {{ noteData.displayCar1 }}
                </label>
              </conversationIconKey>

              <!-- Vehicle of interest -->
              <conversationIconKey class="info" :hasIcon="true" v-if="noteData.displayCar2">
                <i class="zmdi zmdi-car" slot="icon"></i>
                <label class='sub' slot="keyLabel">
                  {{ noteData.displayCar2 }}
                </label>
              </conversationIconKey>

              <!-- Service appt -->
              <conversationIconKey class="info" :hasIcon="true"  v-if="noteData.displayCalendarSales">
                <i class="zmdi zmdi-calendar-alt" slot="icon"></i>
                <label class='sub' slot="keyLabel">
                  {{ noteData.displayCalendarSales }}
                </label>
              </conversationIconKey>

              <conversationIconKey class='info' :hasIcon="true" v-if="noteData.displayStatus">
                <i class='zmdi zmdi-car' slot="icon"></i>
                <label class='sub' slot="keyLabel">
                  {{ noteData.displayStatus }}
                </label>
              </conversationIconKey>

              <conversationIconKey class='info' :class='{red: data.tempData.amountDue}' :hasIcon="true" v-if="noteData.displayOwed">
                <i class="zmdi zmdi-money" slot="icon"></i>
                <label class='sub' slot="keyLabel">
                  {{ noteData.displayOwed }}
                </label>
              </conversationIconKey>
            </div>


              <conversationIconKey class='info' :class='{red: noteData.displayAppointmentRed}' v-if="noteData.displayAppointment">
                <i class="zmdi zmdi-account-calendar"></i>
                <label class='sub' slot="keyLabel">
                  {{ noteData.displayAppointment }}
                </label>
              </conversationIconKey>
          </div>


          <div class='headline-actions'>
            <div class='crm-links' v-if='!liveCallMobile'>
              <button v-if="data.smsPassthrough.label" @click="openSmsPassthrough()">
                {{data.smsPassthrough.label}}
              </button>

              <button @click="openCrm('sales')" v-if='data.crm.showSales'>
                {{data.crm.sales}}
              </button>

              <button @click="openCrm('service')" v-if='data.crm.showService'>
                {{data.crm.service}}
              </button>
            </div>

            <div class='followers' v-if='(v2 && !liveCallMobile) || (v2 && liveCallMobile && data.tempData.liveCallMobileExpanded)'>
              <div class="followButton" :value="user.leuserid" @click='addUserAsFollower($event)'>
                <i class='material-icons-outlined' v-if='!currentThread.userIsFollowing'>person_pin</i>
                <i class='material-icons-round' v-else>person_pin</i>
              </div>

              <label class='sub' @click="manageFollowers()" id="followerstext">
                {{followerCount}} followers
              </label>
            </div>
          </div>
        </div>
      </div>

      <div id="scrollingSection" class="messages-container">
        <loadingGif optionalClass="loading-container" v-if="loadingConvo"></loadingGif>

        <div class="message-row" v-for="(message, index) in messages" :class="{client: message.inbound, sms: message.IsSent || message.SmsThreadId || newSentText, 'note-row': message.type == 4}">

          <div class="timeStampRow" v-if="message.type !== 4">
            <div :class='{disclaimer: !liveCallMobile}'>{{ messages[index].datetime }}</div>

            <label :class='!liveCallMobile ? "small":"sub"' v-if='messages[index].agent && messages[index].agent.Phonecode'>{{ messages[index].agent.Phonecode.lename }}</label>
            <label :class='!liveCallMobile ? "small":"sub"' v-if='!messages[index].agent && !message.frn_zwid'>Unknown</label>

            <div class='forwardIndicator'  v-if="messages[index].forwardedTo && messages[index].forwardedTo !== null">
              <i class="zmdi zmdi-forward"></i>
              <div class='forwardedTooltip disclaimer'>
                 Forwarded to {{messages[index].forwardedTo}}
              </div>
            </div>
          </div>

          <cxDetails v-if="message.type != 3 && message.callid" :callidsThatHavePriorOutcomes="callidsThatHavePriorOutcomes" :messageindex="index" :options='options' :cxMobile='liveCallMobile' @checkFirstCX='checkFirstCX()' :lastCX='messages.length - 1' :seenby="seenCalls.filter(function (e) {return e.frncallid == message.callid;})" :triggerTime="lastTriggered" :seenactions="seenActions.filter(function (e) {return e.frncallid == message.callid;})" :crmInfo="data.crmInfo" :unaddressed="message.Unaddressed" @toggleUnaddressed="toggleUnaddressed" :displayNum="conversation.displayNum" :trackinglinename="conversation.tlInfo"/>

          <msgDetails v-if="message.frn_zwid" :messageindex="index" :options='options' :msgMobile='liveCallMobile' :link='link' :blocked='isBlocked' :unaddressed="message.Unaddressed" @toggleUnaddressed="toggleUnaddressed" :displayNum="conversation.displayNum" :trackinglinename="conversation.tlInfo"/>

          <div class="note" v-if='message.type == 4'>
            <div class="noteBody">
                <i class="zmdi zmdi-comment-edit"></i>
                <div class='noteContent'>{{message.comment}}</div>
            </div>

            <div class='noteMeta'>
              <label class='sub'>{{message.User.descrip1}}</label>
              <div class='disclaimer'>{{message.formattedDate}}</div>
            </div>
          </div>

          <p class="alertMessageLCM" v-if="index === messages.length - 1 && data.tempData.messageAlertingUserName">
            <label  v-show='data.tempData.messageAlertDisplay' v-if="data.tempData.taggedValidUser">
              {{data.tempData.messageAlertingBody}} <span class='name'>{{data.tempData.messageAlertingUserName}}</span>.
            </label>

            <label  v-show='data.tempData.messageAlertDisplay' class="InvalidAtTarget" v-else>
              {{data.tempData.messageAlertingUserName}} is not receiving notifications.
            </label>
          </p>
        </div>
      </div>
    </div>

    <div class="respond-container">
      <div class="replyBarMessages" v-show='data.replyType.text && this.$store.state.selectedTextLine != 0 || data.replyType.note'>

        <div class="replyBarMessagesTop">
          <label class='MMSUpload' v-if='data.replyType.text && customerConsent && customerConsent.optedIn && !isBlocked' for="text-image" id="hiddenInput" @click='MMSUploadPop(); data.fileTooBig = false;'>
            <input type="file" name="text-image" id="text-image" multiple @change="imagePreview($event)"/>
            <i class="zmdi zmdi-collection-image"></i>
          </label>
          <i class="zmdi zmdi-comment-text replyIcon" v-show='!liveCallMobile' v-else-if='data.replyType.text'></i>
          <i class="zmdi zmdi-comment-edit replyIcon" v-show='!liveCallMobile' v-if='data.replyType.note'></i>

          <div class="contenteditable" ref="replyMsg"  @keydown='override($event)' @keyup='setMessage($event)' contenteditable="true" v-if="(!data.replyType.text || !isBlocked)">
          </div>

          <button class='postButton' v-if='data.replyType.note && !data.replyType.text' :disabled='!validMessage' @click="sendMessage()">POST</button>
          <i v-else-if='data.replyType.text && !isBlocked && !validMessage' class="zmdi zmdi-mail-send sendButton"></i>
          <i v-else-if='data.replyType.text && !isBlocked && validMessage' class="zmdi zmdi-mail-send sendButton active" @click="sendMessage()"></i>

           <label v-if="data.replyType.text && isBlocked" class="textingNotAllowed sub">Text communication with this customer has been blocked by your store. If you feel this is in error, please contact our <a class='link' href="https://carwars.com/platform_a/help.cfm" target="_blank">support team.</a></label>
        </div>

        <div class='sendingFrom' v-if="replyObj.obTexter && data.replyType.text && !isBlocked">
          <i class="zmdi zmdi-open-in-browser" @click="popup.showPop = true; forceShowTextPop = true"></i>
          <label class='sub'>Sending From:  </label>
          <div class='sendingFromTL' v-if="replyObj.obTexter.label1 && replyObj.obTexter.label1 !== ''"> {{replyObj.obTexter.label1}}</div>
          <div class='sendingFromTL' v-else> {{replyObj.obTexter.displaynum}}</div>
        </div>
      </div>

      <div class="reply-container">
          <div title='Call Customer' class='replyButton' @click="callPop()" v-if='!liveCallMobile'>
            <i class='zmdi zmdi-phone'></i>
          </div>

          <div title='Text Customer' class='replyButton' :class='{inactive: (data.replyType.note && !data.replyType.text), active: (!data.replyType.note && data.replyType.text)}' @click="textPop()" v-if='jiveLskins.indexOf(this.account.lskinid) == -1'>
            <i class='zmdi zmdi-comment-text'></i>
            <label class='sub' v-if='liveCallMobile'>COMPOSE TEXT</label>
          </div>

		      <div title='Add Note'  class='replyButton' :class='{inactive: (!data.replyType.note && data.replyType.text), active: (data.replyType.note && !data.replyType.text)}' @click="notesPop()">
            <i class="zmdi zmdi-comment-edit"></i>
            <label class='sub' v-if='liveCallMobile'>ADD NOTE</label>
          </div>
      </div>

      <!--- MMS upload--->
      <div class="imagePreview" v-if="data.showPreview" :class="{fileOnlyPreview: showPreviewImage}">
        <span class="previewWrap">
          <div class="previewTop" v-for="(preview, index) in data.previews">
            <div class="close" @click="removeAttachment(index)" v-if='!data.tempData.sendingMMS'>
            </div>
            <svg class='load' v-else>
              <circle cx='50%' cy='50%' r="42.5%" stroke-width="7.5%" fill='none'/>
            </svg>

            <label class="sub previewTitle" :class="{fileOnlyPreview: showPreviewImage}">{{preview.name}}</label>

            <div class="previewContent" v-if="showPreviewImage">
              <img :src="preview.previewImage">
            </div>
            <label class="noPreviewAvailibleLabel" v-else>No Preview Available</label>
          </div>
        </span>
      </div>
      <label v-show='data.replyType.text && this.$store.state.selectedTextLine != 0' class="showFileSizeFlag" v-if="data.fileWarning">
        File type not supported.
      </label>
      <label v-show='data.replyType.text && this.$store.state.selectedTextLine != 0' class="showFileSizeFlag" v-if="data.fileTooBig">
        Make sure file size is less than 5MB.
      </label>
      <label v-show='data.replyType.text && this.$store.state.selectedTextLine != 0' class="showFileSizeFlag" v-if="data.tooManyFiles">
        Cannot send more than 10 files.
      </label>

      <!--- at tag box-->
      <div class="atTagUserSelect" v-if='taggableAgents.length > 0 && showAtTagMenu && data.tempData.Message.length > 0'>
        <div class="atTagSingleUser" v-for='user in taggableAgents' @click='tagAUser(user.id, user.name)'>
          <div class='imgWrap'>
            <img class="atTagUserImage" :src="user.picture" v-if="user.picture">
            <img class="atTagUserImage" src="//assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_2.jpg" v-else>
          </div>
          {{user.name}}
        </div>
      </div>
    </div>

    <!-- followers popup--->
    <article class='popupBG' v-if='popup.manageFollowers'>
      <div class='popup follower'>
        <div class='title'>
          <h2>Followers</h2>

          <div class='close' @click="manageFollowers()"></div>
        </div>

        <div class='content'>
          <select v-if="user.isManager" id='selectFollower' @change='addPotentialFollower()'>
            <option :value="1" selected disabled>Add A Follower</option>
            <option :value="user.leuserid">{{user.descrip1}}</option>
            <option v-for="obj in getFullAgentList" v-if="obj.leuserid !== user.leuserid && user.isManager" :value="obj.leuserid">{{obj.descrip1}}</option>
          </select>

          <div class="followersList">
            <div v-for="obj in followers" :value="obj.leuserid" class="followerSelect">
              <div class='followerDetail'>
                <div class='imgWrap'>
                  <img :src="obj.Phonecode && obj.Phonecode.pc_avatar ? `https://s3.amazonaws.com/callbox-images-external/avatars/${obj.Phonecode.phonecodeid}.jpg` : 'https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_2.jpg'">
                </div>
                <label>{{obj.descrip1}}</label>
              </div>

              <div v-if="user.leuserid === obj.leuserid" class="close" @click='removeFollower($event)' :value="obj.leuserid"></div>
            </div>
          </div>
        </div>
      </div>

      <div class='popupCloseWrap' @click="manageFollowers()"></div>
    </article>

    <!-- call/text popup -->
    <article class='popupBG' v-if='popup.showPop'>
      <div class='popup'>
        <div class='title'>
          <h2>
            {{iconsArray[replyObj['type']].name}}
            <span v-if="currentThread.name !== 'Customer'">{{currentThread.name}}</span>
            <span v-else>{{formatNumber(currentThread.phone)}}</span>
          </h2>

          <div class='close' @click="hidePopup()"></div>
        </div>

        <div class='content'>
          <p v-show="replyObj.type == 0 && !this.user.Phonecode">Please set up a phone code in your <a class='link' :href='mxYouLink' target="_blank">Staff Profile</a> to use click to call.</p>

          <div v-show="replyObj.type == 1 && textableLineInfo.length !== 0">
            <label>Textable Outbound Line</label>
            <select v-model="replyObj.obTexter">
              <option disabled value="null">Select a Line</option>
              <option v-for="obj in obTextArray" :value="obj" v-if="obj.isPoolNumber === 0 && obj.isActive">{{obj.label1}}</option>
            </select>
          </div>

          <p v-show="replyObj.type == 1 && textableLineInfo.length === 0">
            Cannot reply via text message at this time.<br /> An initiated text from the customer is required.</span>
          </p>

          <p v-show="customerConsent && !customerConsent.confirmedBy && (!customerConsent.optedIn || customerConsent.optedOut) && replyObj.type == 1">
              This customer is not opted-in and has never texted this line before. By clicking "CONFIRM", you agree you have proof of prior express consent to message them from this store's lines.</p>

          <div v-show="replyObj.type == 2">
            <label>Select the Recorded Message</label>
            <select v-model="replyObj.selectedMessage">
              <option v-for="obj in recordMsgArray" :value="obj">{{obj.name}}</option>
            </select>
          </div>
        </div>

        <div class='buttons'>
          <button @click="confirmReply()" :disabled="replyObj.obTexter == null" v-if="replyObj.type !== 0">CONFIRM</button>

          <button @click="confirmReply()" :disabled="!this.user.Phonecode" v-if="replyObj.type === 0">CALL</button>
        </div>
      </div>

      <div class='popupCloseWrap' @click="hidePopup()"></div>
    </article>

    <!-- block/contact popup --->
    <article class='popupBG' v-if="popup.blockPop">
      <div class='popup block'>
        <div class='title' v-if='!blockConfirmPop'>
          <h2 v-if="currentThread.name != 'Customer'">{{currentThread.name}}</h2>
          <h2 v-else>{{formatNumber(currentThread.phone)}}</h2>

          <div class='close' @click="popup.blockPop = false"></div>
        </div>

        <div class='title' v-else>
          <h2>Are you Sure?</h2>
          <div class='close' @click="popup.blockPop = blockConfirmPop = false"></div>
        </div>

        <div class='content' v-if='blockConfirmPop'>
          <p v-if="!blockSuccess && !blockFail">
            All future texts from {{currentThread.phone }} will be blocked.
          </p>
          <p v-else-if="isBlocked && blockSuccess" class="success">
            {{currentThread.phone }} has been blocked, calls and messages from this number will no longer be available.
          </p>
          <p v-else-if="!blockSuccess && blockFail">
            We were unable to block {{currentThread.phone }} at this time, please contact
            <a href="//carwars.com/platform_allies/help.cfm" target="_blank" class="link">support.</a>
          </p>
          <p v-else class="success">
            {{currentThread.phone }} has been blocked successfully.
             <button class="alert" @click="block(currentThread.custNumber)">BLOCK</button>
          </p>
        </div>

        <div class='content' v-else></div>

        <div class='buttons' v-if='!blockConfirmPop'>
          <div class='buttonWrap'>
            <button @click='popup.blockPop = false; callPop()'><i class='zmdi zmdi-phone'></i>call</button>
            <button @click='popup.blockPop = false; textPop()'><i class='zmdi zmdi-comment-text'></i>text</button>
          </div>
          <button class='alt alert' @click="blockConfirmPop = true" v-if="!isBlocked">BLOCK TEXTS</button>
        </div>

        <div class='buttons' v-else>
           <button class="alert" v-if='!blockFail && !blockSuccess' @click="block(currentThread.custNumber)">BLOCK</button>
         </div>
      </div>

      <div class='popupCloseWrap' @click="popup.blockPop = blockConfirmPop = false"></div>
    </article>

    <!-- No CRM popup --->
    <article class='popupBG' v-if="popup.noCrm">
      <div class='popup'>
        <div class='noHeader'>
          <div class='close' @click="hidePopup()"></div>
        </div>

        <div class='content'>
          <p>Want to click directly into customer records in CRM? Contact <a href='tel:214-446-7867' class='link'>214-446-7867</a> and we'll get you set up!</p>
        </div>
      </div>

      <div class='popupCloseWrap' @click="hidePopup()"></div>
    </article>
  </div>
</template>

<script>
var intervalTimer //has to be global d/t some vue weirdness

import $ from 'jquery'
import MsgBanner from '@/components/MsgBanner'
import cxDetails from '@/components/cxDetails'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import msgDetails from '@/components/msgDetails'
require('../assets/css/liveCallMod.css')
import axios from 'axios';
import { sha256, sha224 } from 'js-sha256';
import crypto from 'crypto';
import FormData from 'form-data';
import conversationIconKey from '@/components/conversationIconKey.vue'
import loadingGif from '@/components/loadingGif.vue'

export default {
  name: 'LiveCalls',
  props: ['currentView', 'waveformsArray', 'index', 'liveCallMobile', 'isCallCenter'],
  components: {
    MsgBanner,
    cxDetails,
    msgDetails,
    conversationIconKey,
    loadingGif
  },
  computed: {
    ...mapState({
      hProduct: state => state.currentHproduct,
      crmLinkService: state => state.crmLinkService,
      crmLinkSales: state => state.crmLinkSales,
      conversation: state => state.conversation,
      conversationOwner: state => state.conversationOwner,
      account: state => state.account,
      messages: state => state.currentMessages,
      loadingConvo: state => state.loadingConvo,
      loadedAll: state => state.loadedAll,
      user: state => state.user,
      currentConvoViewId: state => state.currentConvoViewId,
      externalMapping: state => state.externalMapping,
      followers: state => state.currentThread.followers,
      followerCount: state => state.currentThread.followerCount,
      agents: state => state.agents,
      preferredOutboundDnis: state => state.preferredOutboundDnis,
      textableLineInfo: state => state.textableLineInfo,
      cdkData: state => state.cdkData,
      secret: state => state.secret,
      callCenterOutcomeFeatureEnabled: state => state.callCenterOutcomeFeatureEnabled,
      callCenterAgents : state => state.callCenterAgents,
      customerConsent: state => state.customerConsent,
      noteData: state => state.noteData,
      jiveLskins: state => state.jiveLskins
    }),
    ...mapGetters([
      'multiAccount',
      'getFullAgentList',
      'mxYouLink'
    ]),
    options (state) {
			let emails = []
			state.agents.forEach( function(part) {
				if(part.isactive === 1 && part.accountemail) { emails.push(part.accountemail) }
			})
			return emails
    },
    validMessage: function () {
      if (this.data.replyType.text) {
        if (this.data.tempData.MMS.length) {
          if (this.data.tempData.Message.length <= 1000) {
            return true;
          } else {
            return false;
          }
        } else {
          if (this.data.tempData.Message.length > 0 && this.data.tempData.Message.length <= 2048) {
            return true;
          } else {
            return false;
          }
        }
      } else if (this.data.replyType.note && this.data.tempData.Message) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    messages: async function (newMessages) {
      if(newMessages.length) {
        await this.pullSeenActions(newMessages);
      }
      clearInterval(intervalTimer)
      this.timedTrigger()
      this.pullSeenRecords()
      if (this.callCenterOutcomeFeatureEnabled && newMessages.length) {
        await this.checkCallsForPreviousOutcomes();
      }
    },
    textableLineInfo: async function (newLineInfo) {
      this.obTextArray = newLineInfo.map(x => x);
    },
    conversation: async function(newConvo){
      if(! this.loadingConvo)
        this.lookForAtTag();
      if(this.data.tempData.messageAlertingUser)
        this.clearMessage();
      this.isBlocked = this.account.blockedNumbers.indexOf(this.currentThread.custNumber) > -1
      this.setOutboundTextingLine();
      this.blockSuccess = false;
      this.blockFail = false;
    }
  },
  mounted: async function() {
    this.$root.$on('loadCrm', () => {
      this.getCrm();
      this.getshowBannerVar();
      this.getSmsPassthrough();
    });
    if(this.$store.state.user.Phonecode && this.$store.state.user.Phonecode.outbound_frn_dnisid) {
      let dnis = this.$store.state.user.Phonecode.outbound_frn_dnisid
      let url = '/dnis/' + dnis
      let res = await this.axios.get(url)
      this.obCallerArray = [res.data]
    }
    this.link = await this.axios.get(`/platform/${this.user.leuserid}`);
    this.link = this.link.data;
    $('.message-row:has(.note)').addClass('noBorder');

    let cwHProudcts = [1,3,10,11,12,16,17,18,20,21];
    let IntHProduct = parseInt(this.hProduct)
    if (cwHProudcts.indexOf(IntHProduct) !== -1) {
      this.carwars = true;
    }
  },
  data: function () {
    return {
      carwars: false,
      newSentText: false,
      forceShowTextPop: false,
      visibleTop: 0,
      visiblebottom: 0,
      v2: true,
      singlethread: false,
      cxLength: 0,
      callidsThatHavePriorOutcomes: {},
      link: "",
      uiState:{
        hoverIndex: -1
      },
      taggableAgents: [],
      showAtTagMenu: false,
      splitMessage: '',
      data: {
        previews: [],
        previewImage: false,
        previewFileName: false,
        showPreview: false,
        playingVideo: false,
        playingExtension: false,
        showPreviewImage: false,
        fileWarning: false,
        fileTooBig: false,
        tooManyFiles: false,
        smsPassthrough: {
          label: '',
          link: ''
        },
      	replyType: {
      		phone: false,
      		note: false,
      		voiceMail: false,
      		text: false
      	},
        tempData: {
          slide1: null,
          slide3: 0,
          owner: 'temp',
          ownerImg: 'temp',
          ownerFollower: false,
          editWhich: 0,
          messageHover: false,
          voiceMailHover: false,
          noteHover: false,
          Message: '',
          hasNote: false,
          noteAuthor: '',
          noteTime: '',
          noteArray:[],
          liveCallMobileExpanded: false,
          amountDue: false,
          MMS: [],
          sendingMMS: false,
          sendingError: false,
          messageAlertingUser: '',
          messageAlertingUserName: '',
          messageAlertingBody: '',
          messageAlertDisplay: false,
          messageAlertDisplayIndex: 0,
          taggedValidUser: false,
        },
        crm: {
          sales: 'Open in CRM',
          service: '',
          showSales: true,
          showService: false,
          urlSales: '',
          urlService: ''
        },
        owner: {
          name: '',
          tempName: '',
          tempAvatarLink: '',
          avatarLink:''
        },
        follower: {
          followerNum: 4,
          followerArray: [],
          potentialFollowers: []
        }
      },
      currentThread: this.$store.state.currentThread,
      iconsArray: [
        {
          name: 'Call',
          class: 'material-icons md-18',
          content: 'phone'
        },
        {
          name: 'Text',
          class: 'material-icons md-18',
          content: 'message'
        },
        {
          name: 'Send voicemail to',
          class: 'material-icons md-18',
          content: 'voicemail'
        },
        {
          name: 'note',
          class: 'material-icons md-18',
          content: 'note'
        }
      ],
      popup: {
        manageFollowers: false,
        showPop: false,
        noCrm: false,
        blockPop: false
      },
      recordMsgArray: [],
      obCallerArray: [],
      obTextArray: [],
      replyObj: {
        inbound: false,
        obCaller: null,
        obTexter: null,
        type: 0,
        recap: null,
        tlLabel: null,
        tlNumber: null,
        tlExt: null,
        account: null,
        replyText: '',
        handler: {},
        details: {
          outcome: '',
          negHCO: '',
          answerTime: 1,
          duration: '',
          recap: '',
          talkTime: 29,
          tlLabel: '',
          tlNumber: '',
          tlExt: '',
          account: ''
        },
        noteText: ''
      },
      seenCalls:[],
      seenActions: [],
      timeTrigger: 1000,
      lastTriggered: '',
      internalUser: false,
      pauseEnterEvent: false,
      isBlocked: false,
      blockConfirmPop: false,
      blockFail: false,
      blockSuccess: false,
      showBannerVar: false
    }
  },
  methods: {
    toggleExpandCampaign:function(index){
      var tempCampaigns = this.currentThread.campaigns
      this.currentThread.campaigns = []
      for (var i = 0; i < tempCampaigns.length; i++) {
        if (i === index) {
          tempCampaigns[i].expanded = !tempCampaigns[i].expanded
        }
        else{
          tempCampaigns[i].expanded = false
        }
        this.currentThread.campaigns.push(tempCampaigns[i])
      }
    },
    formatNumber: function (number) {
      var cleaned = ('' + number).replace(/\D/g, '');
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return match[1] + '-' + match[2] + '-' + match[3];
      }
      return null;
    },
    block: async function(number){
      var that = this;

      let request = {
        ani: this.currentThread.custNumber,
        lskinid: this.currentThread.lskinid,
        leuserid: this.user.leuserid
      }

      let hash = crypto.createHmac("sha256", this.secret)
        .update(JSON.stringify(request))
        .digest("hex");

      this.axios.post(`https://texting.callbox.com/v2/api/blockAni`, request, {
        transformRequest: [
          (data, headers) => {
            delete headers.common.Authorization; return JSON.stringify(data)
          }
        ],
        headers: {
          'Content-Type': 'application/json',
          'Hash': hash
        },
      }).then(function() {
        that.$emit('blocked', number)
        that.isBlocked = true
        that.blockSuccess = true
        that.account.blockedNumbers.push(that.currentThread.custNumber)
      }).catch(function(err) {
        that.blockFail = true
        that.blockSuccess = false
      })

      setTimeout(function(){
        that.blockConfirmPop = that.popup.blockPop = false
      }, 1500);
    },
    override: function(event){
      if (event.keyCode == 13) {
        event.stopPropagation()
        event.preventDefault()
      }
    },
    setMessage: function(event){
      if (event.keyCode !== 13) {
        var inputText = this.$refs.replyMsg.textContent
        var maxlength = this.data.tempData.MMS ? 1000 : 2048
        if(inputText.length < maxlength){
          this.data.tempData.Message = inputText
        }
        else{
          this.$refs.replyMsg.textContent = this.data.tempData.Message
        }
        this.lookForAtTag()
      }
      else{
        event.stopPropagation()
        event.preventDefault()
        if(!this.pauseEnterEvent){
          this.pauseEnterEvent = true;
          this.sendMessage()
          this.pauseEnterEvent = false;
        }
      }
    },
    timedTrigger: function(){
      var that = this
      intervalTimer = setInterval(function(){
        that.scrollHandler()
        that.lastTriggered = Date.now()
      },
     3000);
    },
    scrollHandler: function(){
      var newRecords = this.seenCalls.filter(function(a){return a.newRecord === true})
      var calls = document.getElementsByClassName("callBox");
      var that = this
      if(newRecords.length < calls.length){
        var newScrollTime = Date.now()
        if (this.lastTriggered === "" || !this.lastTriggered) {
            this.lastTriggered = newScrollTime
        }
        else if ((newScrollTime - this.lastTriggered) > this.timeTrigger) {
            this.checkViewed()
            this.lastTriggered = newScrollTime
        }
      }
      else{
       this.lastTriggered = Date.now()
       this.checkViewed()
       if( this.lastTriggered && this.seenCalls[0] && (this.lastTriggered - this.seenCalls[0].insertTime > 9000)){
          this.lastTriggered = false
          clearInterval(intervalTimer);
       }
      }
    },
    checkViewed: async function(){
      var visibleTop = document.getElementById('scrollingSection').getBoundingClientRect().top
      var visiblebottom = window.innerHeight
      var allCalls = document.getElementsByClassName("callBox");
      for (var i = 0; i < allCalls.length; i++) {
        var top = allCalls[i].getBoundingClientRect().top;
        var bottom = allCalls[i].getBoundingClientRect().bottom;
        var middle = top + ((bottom - top) /2)
        var callid = allCalls[i].id
        if ( (middle > visibleTop && middle < visiblebottom) && (top > visibleTop && top < visiblebottom) && (bottom > visibleTop && top < visiblebottom)) {
          if(this.seenCalls.length >= 0){
            var callindex = this.getSpecificSeenCallIndex(callid, this.user.leuserid)
            if(callindex == -1) {
              if(this.user.descrip1.indexOf('Call Box #') == -1){
                this.seenCalls.unshift({
                  frncallid: callid,
                  src: 4,
                  name: this.user.descrip1,
                  time: this.GetFormattedDate(),
                  userid:  this.user.leuserid,
                  userImg: this.user.Phonecode.pc_avatar,
                  newRecord: true,
                  viewedInterally: this.internalUser
                })
                this.insertedNewSeenRecord = true;
              }
            } else if(!this.seenCalls[callindex].insertTime) {
              this.seenCalls[callindex].newRecord = true;
              this.seenCalls[callindex].time = this.GetFormattedDate();
            }
          }
        }
      }
      this.insertSeenRecord();
    },
    insertSeenRecord: function(){
      for (var i = 0; i < this.seenCalls.length; i++) {
        if(this.seenCalls[i].newRecord && !this.seenCalls[i].insertTime){
          let url = `/calls/${this.seenCalls[i].frncallid}/seen`;
          let res = this.axios.post(url, {
            leuserid: this.user.leuserid
          })
          this.seenCalls[i].insertTime = Date.now();
        }
      }
    },
    calcMonth: function(month){
      switch(month) {
        case 0:
          return 'Jan';
        case 1:
          return 'Feb';
        case 2:
          return 'Mar';
        case 3:
          return 'Apr';
        case 4:
          return 'May';
        case 5:
          return 'Jun';
        case 6:
          return 'Jul';
        case 7:
          return 'Aug';
        case 8:
          return 'Sept';
        case 9:
          return 'Oct';
        case 10:
          return 'Nov';
        case 11:
          return 'Dec';
      }
    },
    GetFormattedDate: function(dateIn = moment.utc().tz("America/Chicago")) {
      // Takes in a moment object in CST time and formats it to
      // the desired format and timezone of the user's lskin
      dateIn = dateIn.hour(dateIn.hour() + this.account.letimeadjust)
      var month = this.calcMonth(dateIn.month());
      var date = dateIn.date();
      var hour = dateIn.hour();
      var min = dateIn.minute();
      var year = dateIn.year();
      var ampm = '';
      if (hour > 11) {
        ampm = 'PM';
        if(hour !== 12){
          hour = parseInt(hour) - 12;
        } else {
          hour = parseInt(hour);
        }
      }else{
        if(hour === 0){
          hour = 12;
        }
        ampm = 'AM';
        hour = parseInt(hour);
      }
      if(min < 10){
        min = "0" + min;
      }
      var timeFormatted =  month +' ' + date + ' - ' + hour + ':' + min + ' ' + ampm;
      return timeFormatted;
    },
    pullSeenActions: async function(messages) {
      try {
        let callids = messages.map(function (message) {
          if(!isNaN(message.callid)) {
            return message.callid;
          }
        })
        if (callids) {
          let seenActionResponse = await this.axios({
            method: 'post',
            url: '/calls/seen/actions',
            data: {
              callIds: callids
            }
          })
          this.seenActions = seenActionResponse.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    pullSeenRecords: async function(){
      let url = `/calls/seen/${this.currentThread.lskinid}/${this.currentThread.custNumber}`;

      // For guid
      if (this.conversation && this.conversation.conversation && this.conversation.conversation.interaction.type == 'Call' && isNaN(this.conversation.conversation.interaction.call._id)) {
        url = `${url}/${this.conversation.conversation.interaction.call._id}`;
      } else {
        url = `${url}/0`;
      }

      let res = await this.axios.get(url);

      for(var i = 0; i < res.data.length; i++){
        var callindex = this.getSpecificSeenCallIndex(res.data[i].Callid, res.data[i].Leuserid)

        if(res.data[i].pc_avatar === 1){
          var userImg = 'https://s3.amazonaws.com/callbox-images-external/avatars/'+res.data[i].Leuserid+'.jpg';
        } else {
          var userImg = 'https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_unknown.jpg';
        }
        if(callindex == -1){
          this.seenCalls.push({frncallid: res.data[i].Callid.toLowerCase(), name: res.data[i].descrip1, src: res.data[i].SourceId, time: this.GetFormattedDate(moment.parseZone(res.data[i].DateSeen)), userImg: userImg, userid: res.data[i].Leuserid, newRecord: false, viewedInterally: false})
        }
      }
      clearInterval();
    },
    getSpecificSeenCallIndex: function( callid, userid ) {
      for(var i = 0; i < this.seenCalls.length; i++){
        if(this.seenCalls[i].frncallid.toLowerCase() == callid.toLowerCase() && this.seenCalls[i].userid == userid){
          return i;
        }
      }
      return -1;
    },
    tagAUser: function(userid, userName){
      this.showAtTagMenu = false;
      var messageOne = this.data.tempData.Message.split('@')[0];
      this.data.tempData.Message = messageOne + ' @' + userName;
      this.data.tempData.messageAlertingUser = userid;
      this.data.tempData.messageAlertingUserName = userName;
      this.$refs.replyMsg.textContent = this.data.tempData.Message;
    },
    lookForAtTag: function(){
      if (this.data.tempData.Message.indexOf('@') > -1){
        var atIndex = this.data.tempData.Message.indexOf('@')
        this.splitMessage = this.data.tempData.Message.split('@')[1]
        this.showAtTagMenu = true
        this.taggableAgents = []
        for (var i = 0; i < this.agents.length; i++) {
          if(this.agents[i].descrip1.toUpperCase().indexOf(this.splitMessage.toUpperCase()) > -1){
            this.taggableAgents.push({name: this.agents[i].descrip1, id: this.agents[i].leuserid, picture:this.agents[i].Phonecode.pc_avatar})
          }
        }
      }
      else{
        this.showAtTagMenu = false
      }
    },
    checkCallsForPreviousOutcomes: async function () {
      return new Promise ( async (resolve, reject) => {
        try {
          const endpoint = `callcenterOutcome/checkPreviousOutcomes`;
          const callids = this.messages.map( (message) => {
            if (message.type === 1 && message.callid) {
              return message.callid
            }
          });
          const res = await axios.post(endpoint, {
            ids: callids
          });

          const callidsOutcomesMap = {};
          if (res.data && res.data.length) {
            res.data.map( (outcomeResult) => {
              callidsOutcomesMap[outcomeResult] = true;
            })
          }

          this.callidsThatHavePriorOutcomes = callidsOutcomesMap;

          return resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    validFileType: function (file) {
      var acceptableTypes = ["image/jpeg", "image/gif", "image/png", "application/pdf", "image/jpg","image/bmp","image/tiff", "video/mp4", "video/mov", "video/quicktime", "video/avi", "video/mpg", "video/mpeg", "audio/mpeg", "text/plain"];
      var acceptableExtensions = [".jpeg", ".gif", ".png", ".txt", ".pdf", ".jpg", ".bmp", ".tiff", ".tif",".webm", ".mov", ".wmv", ".rtf", ".m4a", ".m4p", ".m4b",".m4r", ".mp1", ".mp2", ".mp3", ".m1a", ".m2a", ".mpa", ".wav", ".3ga", ".3gp", ".pjpeg", ".mp4", ".m4v", ".mpg", ".mpeg", ".m1v", ".mpv", ".qt"];
      var inputFileExtension = file.name.substring(file.name.length, file.name.indexOf("."));

      if (acceptableTypes.indexOf(file.type) > -1 && file.type.length > 1) {
        this.showPreviewImage = true
        return true;
      }
      else if (file.type.length < 1 && acceptableExtensions.indexOf(inputFileExtension) > -1) {
        this.showPreviewImage = false
        return true;
      }
      else{
        return false;
      }
    },
    MMSUploadPop: function(){
      setTimeout(function () {
          this.data.fileWarning = false
      }.bind(this), 3000)
    },
    validFileSize: function (file) {
      var fileSizeLimit = 5000000 // 5MB

      if (file.size <= fileSizeLimit) {
        return true;
      }

      return false;
    },
    imagePreview: function(e) {
      // this method takes files from the file input and adds them to this.data.tempData.MMS and adds previews to this.data.previews
      // then clears the file input 
      var files = e.target.files;
      var that = this;
      var acceptableTypes = ["image/jpeg", "image/gif", "image/png", "application/pdf", "image/jpg","image/bmp","image/tiff" ];

      if (files.length) {
        if (this.data.tempData.MMS.length + files.length > 10) {
          // if already selected files + new selected files is more than 10, let user know with message
          // keep old selected files but do not add new ones
          this.data.fileTooBig = false;
          this.data.fileWarning = false;
          this.data.tooManyFiles = true;

          // clear out the file input so it can listen for new files
          e.currentTarget.value = null;
          return;
        }

        // validate all files first
        for (let index = 0; index < files.length; index++) {
          const file = files[index];
          
          if (!this.validFileType(file)) {
            this.data.fileWarning = true;
            this.data.fileTooBig = false;
            this.data.tooManyFiles = false;
            this.data.previews = [];
            this.data.tempData.MMS = [];
            this.data.showPreview = false;

            // clear out the file input so it can listen for new files
            e.currentTarget.value = null;
            return;
          } else if (!this.validFileSize(file)) {
            this.data.fileTooBig = true;
            this.data.fileWarning = false;
            this.data.tooManyFiles = false;
            this.data.previews = [];
            this.data.tempData.MMS = [];
            this.data.showPreview = false;

            // clear out the file input so it can listen for new files
            e.currentTarget.value = null;
            return;
          }
        }

        // set up the file previews
        for (let index = 0; index < files.length; index++) {
          const file = files[index];

          // get filename
          let previewFileName = file.name;

          // get file type
          var reader = new FileReader();
          reader.onload = function (readFile) {
            let previewImage = '';
            if (acceptableTypes.indexOf(file.type) > -1) {
              previewImage = readFile.target.result;
            } else {
              previewImage = '';
            }
            // push preview data
            this.data.previews.push({
              name: previewFileName,
              previewImage: previewImage
            });
            // push actual file
            this.data.tempData.MMS.push(file);
          }.bind(this);
          reader.readAsDataURL(file);
        }
        // removing file by clicking x button does not modify the file input's filelist
        // so we need to clear out the file input so it can listen for new files again
        e.currentTarget.value = null;
        this.data.fileWarning = false;
        this.data.fileTooBig = false;
        this.data.showPreview = true;
        this.data.tooManyFiles = false;
      }
    },
    removeAttachment: function(index) {
      this.data.previews.splice(index, 1);
      this.data.tempData.MMS.splice(index, 1);
      this.data.tooManyFiles = false;

      // if the array is now empty, reset the reply bar state
      if (this.data.previews.length === 0 && this.data.tempData.MMS.length === 0){
        this.data.previewImage = false;
        this.data.showPreview = false;
        this.data.tooManyFiles = false;
        this.data.fileTooBig = false;
      }
    },
    getHash: function (request) {
      return crypto.createHmac("sha256", this.secret)
        .update(JSON.stringify(request))
        .digest("hex");
    },
    getHashWorkaround: function (workaroundString) {
      return crypto.createHmac("sha256", this.secret)
        .update(workaroundString)
        .digest("hex");
    },
    expandMobileTopDisplay: function () {
      this.data.tempData.liveCallMobileExpanded = !this.data.tempData.liveCallMobileExpanded;
      this.data.replyType.note = false;
      this.data.replyType.text = false;
    },
    checkFirstCX: function () {
      this.cxLength = this.messages.length -1
    },
    toggleUnaddressed: async function(event) {
      if (event.unaddressed) {
        this.messages[event.index].Unaddressed = event.unaddressed;
      } else {
        await this.$store.dispatch('markAddressed', event.datetime);
      }
    },
    notesPop: function () {
      this.data.replyType.note = true;
      this.data.replyType.text = false;
      this.data.replyType.phone = false;
      this.data.replyType.phone = false;
    },
    addUserAsFollower: function ($event) {
      let userid = this.user.leuserid;
      let conversationid = this.currentThread.conversationid;

      if (this.currentThread.userIsFollowing === false) {
        this.$store.commit({
          type: 'addFollower',
          conversationid: conversationid,
          userid: userid,
          newFollower: this.user
        });

      } else if (this.currentThread.userIsFollowing  === true) {

        this.data.tempData.ownerFollower = false
        this.$store.commit({
          type: 'removeFollower',
          userid: userid,
          conversationid: conversationid
        });
      }
    },
    addPotentialFollower: function ($event) {
      let userid = $('#selectFollower :selected').attr('value')
      let newFollower;
      if (userid == this.user.leuserid) {
        newFollower = this.user;
        this.data.tempData.ownerFollower = true;
      }
      if (newFollower === undefined) {
        newFollower = this.getFullAgentList.find(o => o.leuserid == userid);
      }
      this.$store.commit({
        type: 'addFollower',
        conversationid: this.currentThread.conversationid,
        userid: userid,
        newFollower: newFollower
      });
      $('#selectFollower').val(1);
    },
    manageFollowers: function () {
      this.popup.manageFollowers = !this.popup.manageFollowers;
    },
    addNote: function () {
      if (this.noteText !== '') {
          var noteObj = {
            date: 'Feb 26 09:30 AM',
            type: 3
          }
          noteObj.content = this.noteText
          this.currentThread.messagesArray.push(noteObj)
          this.noteText = ''
          setTimeout(this.scrollMessages, 300)
      }
    },
    load45: function () {
       this.$root.$emit('load45days', { message: 'load45Days'})
    },
    setOutboundTextingLine: function() {
      // Set default outbound texting line
      let currentAgentsLine = this.obTextArray.filter(line => line.agentLine == this.user.leuserid);
      let possibleDnises = this.obTextArray.map(x => x.dnisid);
      let mostRecentLine;

      // Find the most recently texted
      for(var i = this.messages.length - 1; i >= 0; i--){
        if(this.messages[i].SmsThreadId && this.messages[i].inbound && possibleDnises.indexOf(this.messages[i].DnisId) > -1){
          mostRecentLine = this.obTextArray.filter(line => line.dnisid == this.messages[i].DnisId)[0];
          break;
        }else if(moment().diff(moment(this.messages[i].datetime), 'days') > 45){
          console.log("No recent inbound texts")
          break;
        }
      }

      if (this.obTextArray.length == 1 && this.obTextArray[0].isAgentLine == 0) {
        this.replyObj.obTexter = this.obTextArray[0];
      } else if(mostRecentLine){
        this.replyObj.obTexter = mostRecentLine;
      } else if(currentAgentsLine.length > 0){
        this.replyObj.obTexter = currentAgentsLine[0];
      } else {
        this.replyObj.obTexter = null;
        this.forceShowTextPop = true;
      }
    },
    callPop: function () {
      if(this.obCallerArray.length == 1){
        this.replyObj.obCaller = this.obCallerArray[0]
      }else {
        this.replyObj.obCaller = null
      }
      this.replyObj.date = 'May 30 09:30 AM'
      this.replyObj.type = 0
      this.usagePopController()
    },
    textPop: function () {
      this.replyObj.type = 1;
      this.data.replyType.text = true
      this.data.replyType.note = false;
      this.data.replyType.phone = false;

      if(!(this.customerConsent.optedIn || this.customerConsent.confirmedBy) || !this.replyObj.obTexter){
        this.usagePopController();
      } else {
        this.confirmReply();
      }
    },
    usagePopController: function () {
      if (this.$store.state.showReplyPopup) {
        this.popup.showPop = true
        this.$store.state.showUsagePopup = false
      } else {
        this.popup.showPop = false
        this.$store.state.showUsagePopup = true
      }
    },
    hidePopup: function () {
      this.popup.showPop = false;
      this.popup.noCrm = false;
      this.forceShowTextPop = false;
    },
    confirmReply: async function () {
      if (this.replyObj.type === 0) {
        let ctcDetails = {
          ani: this.currentThread.phone.replace(/\D/g,''),
          phonecode: this.$store.state.user.frn_phonecodeid
        }
        let finalUrl = this.buildCtcUrl(ctcDetails)
        let res = await this.axios.get(finalUrl, {
          transformRequest: [
            (data, headers) => {
              delete headers.common.Authorization; return data
            }
          ],
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        if (res.status === 200) {
          this.replyObj.date =  moment().format('MMM DD hh:mm A'),
          this.replyObj.type = 1
          this.replyObj.audio = {},
          this.replyObj.details = {},
          this.replyObj.hcats = {},
          this.replyObj.dnis = {}
        }
      } else if (this.replyObj.type === 1) {
        if(!(this.customerConsent.optedIn || this.customerConsent.confirmedBy)){
          let request = {
            customerNumber: this.currentThread.custNumber,
            lskinid: this.account.lskinid,
            userid: this.user.leuserid,
          }

          if(this.customerConsent[0]){
            //create consent
            let consent = await this.axios.post('https://texting.callbox.com/v2/api/consent', request, {
              transformRequest: [
                (data, headers) => {
                  delete headers.common.Authorization; return JSON.stringify(data)
                }
              ],
              headers: {
                'Content-Type': 'application/json',
                'Hash': this.getHash(request)
              }
            });

            this.$store.commit({
              type: 'storeConsent',
              consent: consent.data
            });
          }
        }

        Promise.all([
          this.$store.commit({
            type: 'updateSelectedTextLine',
            lineObj: this.replyObj.obTexter
          })
        ]).then((results) => {
          this.$nextTick(() => this.$refs.replyMsg.focus())
        });

        this.forceShowTextPop = false;
      }
      var newObj = Object.assign({}, this.replyObj)
      this.currentThread.messagesArray.push(newObj)
      this.hidePopup()
    },
    buildCtcUrl: function (params) {
      let ctcUrl = new URL("https://partner.dialtag.com/ctc.cfm?partner=callbox&")
      ctcUrl.searchParams.append('dial1', this.user.Phonecode.phone);
      ctcUrl.searchParams.append('dial2', params.ani);
      ctcUrl.searchParams.append('lid', this.account.lskinid);
      ctcUrl.searchParams.append('phoneCode', params.phonecode);
      return ctcUrl;
    },
    scrollMessages: function () {
      var myElement = document.querySelector('.messages-container')
      myElement.scrollTop = myElement.scrollHeight
    },
    removeFollower: function ($event) {
      let userid = parseInt($(event.target).attr('value'));
      let conversationid = this.currentThread.conversationid;

      this.$store.commit({
        type: 'removeFollower',
        userid: userid,
        conversationid: conversationid
      })
      $('#newfollowerDropDown').val(1);
    },
    getCrm: async function() {
      // Wipe the values.
      this.data.crm.urlSales = '';
      this.data.crm.urlService = '';
      this.data.crm.showSales = true;
      this.data.crm.showService = false;
      this.data.crmInfo = '';

      /** Get CRM info for shares from xxml_join */
      let res = await this.axios.get(`/accounts/${this.account.lskinid}/crms`);
      this.data.crmInfo = res.data;

      let endpoint = '/hproductPassthrough/',
          lskin = this.account.lskinid,
          urlService = '',
          urlSales = '',
          url = endpoint + lskin

      /** grab hproduct records and set the crm button(s) text and url to the returned pt_reference/pt_link values */
      res = await this.axios.get(url, {
        responseType: 'json'
      })

      if (res.data && res.data.length > 0) {
        if (res.data.length > 1) {
          if (res.data[1].frn_hproductid == 3) {
            this.data.crm.urlService = res.data[1].pt_link
            this.data.crm.service = res.data[1].pt_reference
          } else {
            this.data.crm.urlSales = res.data[1].pt_link
            this.data.crm.sales = res.data[1].pt_reference
          }
        }

        if (res.data[0].frn_hproductid == 3) {
          this.data.crm.urlService = res.data[0].pt_link
          this.data.crm.service = res.data[0].pt_reference
        } else {
          this.data.crm.urlSales = res.data[0].pt_link
          this.data.crm.sales = res.data[0].pt_reference
        }

        if (this.data.crm.sales.indexOf('CAN') !== -1) {
          let endpoint = '/externalMapping/'
          let url = endpoint + lskin

          let res = await this.axios.get(url, {
            responseType: 'json'
          })

          if (res.data !== null) {
            let mapping = res.data.external_mapping
            let newUrl = this.data.crm.urlSales.replace('{external_mapping}', mapping);

            this.data.crm.urlSales = newUrl
          }

        }

        if (this.data.crm.sales.indexOf('DealerSocket') !== -1) {
          let endpoint = '/externalMapping/' + lskin
          let resMapping = await this.axios.get(endpoint, {
            responseType: 'json'
          })

          if (resMapping.data!== null) {
            let mapping = resMapping.data.external_mapping;
            this.$store.commit({
              type: 'updateExternalMapping',
              value: mapping
            })
          }
        }

        if (this.data.crm.urlSales.indexOf('elead') !== -1) {
          this.data.crm.urlSales = '//carwars.com/passthrough/' + this.data.crm.urlSales
        }

        if (this.data.crm.urlService.indexOf('elead') !== -1) {
           this.data.crm.urlService = '//carwars.com/passthrough/' + this.data.crm.urlService
        }
      }

      /** update the global structure crm url values */
      this.$store.commit({
          type: 'updateCrmLink',
          serviceLink: this.data.crm.urlService,
          salesLink: this.data.crm.urlSales
      })

      if (this.crmLinkSales === '' && this.crmLinkService === '') {
        this.data.crm.sales = 'Open in CRM'
        this.data.crm.showService = false;
      } else {
        if (this.crmLinkSales.indexOf("elead") !== -1 || this.crmLinkSales.indexOf("lightning") !== -1 || this.crmLinkSales.indexOf("azure") !== -1 || this.crmLinkSales.indexOf("vin") !== -1 || this.crmLinkSales.indexOf("dealersocket") !== -1 || this.crmLinkSales.indexOf("dealerpeak") !== -1 || this.crmLinkSales.indexOf("core") !== -1 || this.crmLinkSales.indexOf("callaneighbor") || this.crmLinkSales.indexOf("interstatecargo")) {
          this.data.crm.showSales = true;
        } else {
          this.data.crm.showSales = false;
        }

        if (this.crmLinkService.indexOf("xtime") !== -1 || this.crmLinkService.indexOf("vin") !== -1 || this.crmLinkService.indexOf("connectcdk") !== -1) {
          this.data.crm.showService = true;
        } else if (this.crmLinkService.indexOf("dealersocket") !== -1 || this.crmLinkService.indexOf("elead") !== -1) {
          this.data.crm.showService = true;
          this.data.crm.service = this.data.crm.service + ' Service'
        } else {
          this.data.crm.showService = false;
        }
      }
    },
    getshowBannerVar: async function() {
        let res = await this.axios.get(`reg10DLC/${this.account.lskinid}/${this.user.leuserid}`);
          this.data.showBannerVar = res.data
          console.log('showBannerVar',res.data);
        },
    getSmsPassthrough: async function () {
      let endpoint = '/smsPassthrough/',
          lskin = this.account.lskinid,
          url = endpoint + lskin

      /** grab sms passthrough product records and set the sms passthru button(s) text and url to the returned PlatformName/PassthroughLink values */
      let res = await this.axios.get(url, {
        responseType: 'json'
      })

      if (res.data && res.data.length > 0) {
        this.data.smsPassthrough.label = res.data[0].PlatformName;
        this.data.smsPassthrough.link = res.data[0].PassthroughLink.replace('{phone}',this.currentThread.custNumber);
      }
    },
    openSmsPassthrough: function () {
      window.open(this.data.smsPassthrough.link,"_blank");
    },
    updateView: async function (convoid) {
      let endpoint = `/conversations/viewsUpdate`;
      let res = await this.axios.post(endpoint, {
        id: this.currentConvoViewId,
        end: 0,
        opened: 1
      }).then(res =>{
      });
    },
    sendMessage: async function (){
      if (this.data.replyType.text) {
        this.data.tempData.Message = this.$refs.replyMsg.textContent
        this.sendSMS(this.$store.state.selectedTextLine, this.data.tempData.Message, this.data.tempData.MMS);
      }
      else if (this.data.replyType.note) {
        let notificationsSent = await this.$store.dispatch('addNote', {
          conversationid: this.currentThread.conversationid,
          content: this.data.tempData.Message,
          leuserid: this.user.leuserid,
          taggedUser: this.data.tempData.messageAlertingUser,
          username: this.user.descrip1,
          phonecodeid: this.user.Phonecode ? this.user.Phonecode.phonecodeid : 0,
          pc_avatar: this.user.Phonecode ? this.user.Phonecode.pc_avatar : '',
          time: moment().toISOString(),
          formattedDate: moment().format('LLL')
        });

        let desktopNoteSent = notificationsSent.data.desktopNotification;
        let mobileNoteSent = notificationsSent.data.mobileNotification;
        let textNoteSent = notificationsSent.data.mobileText;

        if (desktopNoteSent || mobileNoteSent || textNoteSent) {
          this.data.tempData.taggedValidUser = true;
          this.data.tempData.messageAlertingBody = '';

          if(desktopNoteSent){
            this.data.tempData.messageAlertingBody += 'Desktop Notification ';
            if(mobileNoteSent || textNoteSent)
              this.data.tempData.messageAlertingBody += 'and ';
          }
          if(mobileNoteSent){
            this.data.tempData.messageAlertingBody += 'Mobile Notification ';
            if(textNoteSent)
              this.data.tempData.messageAlertingBody += 'and ';
          }
          if(textNoteSent){
            this.data.tempData.messageAlertingBody += 'Text Message ';
          }
          this.data.tempData.messageAlertingBody += 'sent to ';

        } else {
          this.data.tempData.taggedValidUser = false;
        }

        this.data.tempData.messageAlertDisplayIndex = this.cxLength + 1;
        this.data.tempData.messageAlertDisplay = true;

        let that = this
        setTimeout(function(){
          that.data.tempData.messageAlertDisplay = false ;
          that.data.tempData.messageAlertingUserName =  '';
          that.data.tempData.messageAlertDisplayIndex =  0;
        }, 5000);

        this.scrollMessages();
      }

      // When sending a note or text add the current user as a follower.
      if (this.currentThread.userIsFollowing === false) {
        this.$store.commit({
          type: 'addFollower',
          conversationid: this.currentThread.conversationid,
          userid: this.user.leuserid,
          newFollower: this.user
        });
      }

      //when done sending, hide the input bar and reset valid
      if (!this.data.replyType.text || (this.data.replyType.text && this.data.tempData.MMS.length === 0)) {
        this.clearMessage();
      }
    },
    clearMessage: function(){
      this.data.replyType.phone = false;
      this.data.replyType.note = false;
      this.data.replyType.voiceMail = false;
      this.data.replyType.text = false;
      this.data.previewImage = undefined;
      this.data.showPreview = false;
      this.data.Message = '';
      this.data.tempData.messageAlertingUser = undefined;
      this.data.tempData.MMS = [];
      this.data.previews = [];
      this.data.tempData.Message = '';
      this.data.fileWarning = false;
      this.data.fileTooBig = false;
      this.data.tooManyFiles = false;
      this.$refs.replyMsg.textContent = '';
    },
    sendSMS: async function (obLineData, obMessage, obFile) {
      let endpoint = 'https://texting.callbox.com/v2/message/outbound';
      this.newSentText = true; // used to properly format before all texting data is returned from endpoint

      if (obFile) {
        this.data.fileWarning = false;
        this.data.fileTooBig = false;
        this.data.tempData.sendingMMS = true;
        this.data.tempData.sendingError = false;
        var requestFormData = new FormData();
        requestFormData.append('finalSource', obLineData.lednis);
        requestFormData.append('finalDestination', this.currentThread.custNumber);
        requestFormData.append('theBody', obMessage);
        requestFormData.append('theTimestamp', moment().tz('America/Chicago').toISOString(true));
        requestFormData.append('callboxUserId', this.user.leuserid);
        requestFormData.append('source', 'ci');
        for (let i = 0; i < obFile.length; i++) {
          const attachment = obFile[i];
          requestFormData.append('MMS', attachment); 
        }

        let res = await this.axios.post(endpoint, requestFormData, {
          transformRequest: [
            (data, headers) => {
              delete headers.common.Authorization; return data;
            }
          ],
          headers: {
            'Content-Type': 'multipart/form-data',
            'Hash': this.getHashWorkaround('outboundMMSWorkaround')
          }
        }).then(function (res){
          if (res.data){
            this.data.Message = '';
            this.data.tempData.Message = '';
            this.$refs.replyMsg.value = ''
            this.data.tempData.MMS = [];
            this.data.showPreview = false;
            this.data.replyType.text = false;
            this.data.tempData.sendingMMS = false;
            this.data.previews = [];
          }
        }.bind(this))
        .catch(function (err){
          this.data.tempData.sendingMMS = false;
          this.data.tempData.sendingError = true;
        }.bind(this));
      } else {
        var request = {
          finalSource: obLineData.lednis,
          finalDestination: this.currentThread.custNumber,
          theBody: obMessage,
          theTimestamp: moment().tz('America/Chicago').toISOString(true),
          callboxUserId: this.user.leuserid,
          source: "ci"
        }
        await this.axios.post(endpoint, request, {
          transformRequest: [
            (data, headers) => {
              delete headers.common.Authorization; return JSON.stringify(data)
            }
          ],
          headers: {
            'Content-Type': 'application/json',
            'Hash': this.getHash(request)
          }
        });
      }
    },
    formatDate(date) {
      var month = date.substring(0,3)

      if (month == 'Jan') {
        date = date.replace('Jan','January')
      } else if (month == 'Feb') {
        date = date.replace('Feb','February')
      } else if (month == 'Mar') {
        date = date.replace('Mar','March')
      } else if (month == 'Apr') {
         date = date.replace('Apr','April')
      } else if (month == 'Jun') {
        date = date.replace('Jun','June')
      } else if (month == 'Jul') {
        date = date.replace('Jul','July')
      } else if (month == 'Aug') {
        date = date.replace('Aug','August')
      } else if (month == 'Seo') {
        date = date.replace('Sep','September')
      } else if (month == 'Oct') {
        date = date.replace('Oct','October')
      } else if (month == 'Nov') {
        date = date.replace('Nov','November')
      } else if (month == 'Dec') {
        date = date.replace('Dec','December')
      }

      var hour = date.substring(date.length-5,date.length-2)

      if (hour.substring(0) == 0) {
        date = date.replace(hour,hour.substring(1,hour.length))
        date += ' AM'
      } else {
        if (hour == '13:') {
          date = date.replace(hour,'1:')
        } else if (hour == '14:') {
          date = date.replace(hour,'2:')
        } else if (hour == '15:') {
          date = date.replace(hour,'3:')
        } else if (hour == '16:') {
          date = date.replace(hour,'4:')
        } else if (hour == '17:') {
          date = date.replace(hour,'5:')
        } else if (hour == '18:') {
          date = date.replace(hour,'6:')
        } else if (hour == '19:') {
          date = date.replace(hour,'7:')
        } else if (hour == '20:') {
          date = date.replace(hour,'8:')
        } else if (hour == '21:') {
          date = date.replace(hour,'9:')
        } else if (hour == '22:') {
          date = date.replace(hour,'10:')
        } else if (hour == '23:') {
          date = date.replace(hour,'11:')
        } else if (hour == '24:') {
          date = date.replace(hour,'12:')
        }
        date += ' PM'
      }

      return date
    },
    openCrm: function (department) {
      this.updateView(this.currentThread.conversationid);
      var callerphone = this.currentThread.phone.replace(/-/g,'').replace('(','').replace(')','').replace(' ','');
      var lednis = this.conversation.displayNum;
      if (lednis) {
        lednis = lednis.replace(/-/g,'');
      }
      if (lednis) {
        lednis = lednis.replace('(','');
      }
      if (lednis) {
        lednis = lednis.replace(')','');
      }
      if (lednis) {
        lednis = lednis.replace(' ','');
      }
      var zipcode = this.conversation.conversation.interaction.call ? this.conversation.conversation.interaction.call.bridgeval : undefined;
      var url = "";
      if (department == 'sales') {

        if (this.data.crm.sales.indexOf('Open in CRM') > -1) {
          this.popup.noCrm = true
        } else {
          if (this.data.crm.sales.indexOf('Salesforce') !== -1) {
            var searchString = '{"componentDef":"forceSearch:search","attributes":{"term":"PHONE","scopeMap":{"type":"TOP_RESULTS"},"context":{"disableSpellCorrection":false,"SEARCH_ACTIVITY":{"term":"PHONE"}}}}'
            searchString = searchString.replace("PHONE", callerphone);
            url = this.data.crm.urlSales + '#' + btoa(searchString);
          } else if (this.data.crm.sales.indexOf('CAN') !== -1) {
              // Inbound/outbound distinction
              if (this.conversation.type === "IB") {
                // Calling=
                var newUrl = this.data.crm.urlSales.replace('{lednis}', lednis);
                // Caller=
                var newUrl2 = newUrl.replace('{ani}', callerphone);
                // Grab zipcode (bridgeval)
                if (zipcode) {
                  var newUrl2 = `${newUrl2}&CustomerZipCode=${zipcode}`;
                }
                url = newUrl2;
              } else {
                // Calling=
                var newUrl = this.data.crm.urlSales.replace('{lednis}', callerphone);
                // Caller=
                var newUrl2 = newUrl.replace('{ani}', lednis);
                // Grab zipcode (bridgeval)
                if (zipcode) {
                  var newUrl2 = `${newUrl2}&CustomerZipCode=${zipcode}`;
                }
                url = newUrl2;
              }
          }	else if (this.data.crm.sales.indexOf('DealerSocket') !== -1 && this.externalMapping != '0' && this.externalMapping != 'undefined') {
            this.searchDS(callerphone, this.externalMapping)
            return
          } else if (this.data.crm.sales.indexOf('Nexhealth') !== -1) {
            this.searchNexHealthPatiendID(callerphone, this.account.lskinid)
            return
          } else {
            url = this.data.crm.urlSales
          }

          if (this.data.crm.sales.indexOf('DealerPeak') !== -1) {
            url = `https://carwars.com/cx/${url}`;
            url = url.replace("{number}", callerphone);
          } else {
            url = url.replace("{phone}", callerphone);
          }

          if (this.data.crm.sales.indexOf('TrailersPlus') !== -1) {
            url = this.data.crm.urlSales.replace("{phone}", callerphone);
          }

          var win = window.open(url, '_blank');
          setTimeout(function () { win.close();}, 900000);
        }

      } else if (department == 'service') {
        url = this.data.crm.urlService
        url = url.replace("{phone}", callerphone);
        var win = window.open(url, '_blank');
        setTimeout(function () { win.close();}, 900000);
      }
    },
    searchNexHealthPatiendID: async function (caller, lskinid) {
      var nexhealthUrl = this.data.crm.urlSales;

      let endpoint = '/hproductPassthrough/nexhealth';
      let res      = await this.axios.post(endpoint, {
        callerPhone: caller,
        lskinid: lskinid
      });
      if (res.data.length > 0 ) {
        let patientId = res.data[0]['patientId'];
        nexhealthUrl  = nexhealthUrl.replace("{patientid}", patientId);
      } else {
        nexhealthUrl = 'https://app.nexhealth.com/login';
      }
      let win = window.open(nexhealthUrl, '_blank');
      setTimeout(function () { win.close();}, 900000);
    },
    searchDS: async function (caller, external_mapping) {
      var dsUrl = '';
      var this2 = this;

      let endpoint = '/hproductPassthrough/ds';
      let res = await this.axios.post(endpoint, {
        callerPhone: caller,
        lskinid: this.account.lskinid
      });

      if (res.data != -1) {
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(res.data, "text/html");
        let partyIDnodes = xmlDoc.getElementsByTagName("PartyID");

        if (partyIDnodes.length == 0) {
          // if nothing from DS for this customer, go to the search page
          dsUrl = this2.data.crm.urlSales.replace("{phone}", caller);
        } else {
          // got customer info from DS, view it on DS
          let partyID = partyIDnodes[0].childNodes[0].nodeValue;
          dsUrl = 'https://bb.dealersocket.com/#/crm/view/contact/' + partyID;
        }        
      } else {
        dsUrl = this2.data.crm.urlSales.replace("{phone}", caller);
      }
      let win = window.open(dsUrl, '_blank');
      setTimeout(function () { win.close();}, 900000);
    },
    setDefaultImage: function () {
      return "https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_2.jpg"
    },
  },
  beforeMount(){
    this.getshowBannerVar();
    this.getCrm();
  }
}
</script>